import { getRequestContext, getSafeStoresRequestContext } from '../context';
import { checkIsExternalCheckout, checkIsLiteStore } from '../storeInfo';

/**
 * Определяет, находимся ли мы на checkout.merchants.yandex.ru
 * Для локальной/дев/тест сред также проверяет тип магазина в storeInfoRequestContext
 * и тип магазинов в зависимости от роута в storesRequestContext (чтобы разрабатывать/тестировать YCP)
 *
 * @returns true, если находимся на checkout.merchants.yandex.ru, либо работаем в локалке/деве/тесте
 * с YCP/Bitrix/Lite магазином или находимся на роутах заведения/выбора этих типов магазинов
 * @kind helper
 */
export const checkIsYCP = () => {
    const requestCtx = getRequestContext();

    if (requestCtx.isYCPDomain) {
        return true;
    } else if (requestCtx.env === 'production') {
        // В проде достаточно проверять только домен в requestContext, остальные проверки избыточны
        return false;
    }

    // В локальной/дев/тест средах в зависимости от типа магазина рисуем YCP либо Кит кабинет
    if (checkIsExternalCheckout() || checkIsLiteStore()) {
        return true;
    }

    const storesCtx = getSafeStoresRequestContext();

    // В локальной/дев/тест средах роуты /stores/lite(/new)? и /stores/checkouts(/new)? рисуем в стиле YCP
    return storesCtx.storesType !== 'Kit';
};
